import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
import {action, observable} from 'mobx';
import {FormattedMessage} from 'react-intl';
import SvgIcon from '@material-ui/core/SvgIcon';
import FileAttach from '../../../../components/FileAttach';
import CircularLoader from '../../../../components/circularLoader/CircularLoader';
import VideoBox from './VideoBox';
import iconVideo from '../../../../assets/images/video-cam';
import StudioReadOnlyMessage from "../StudioReadOnlyMessage";
import {customEvent} from "../../../../utils/analyticsUtil";
import {actions, category, events} from "../../../../constants/enums";

@inject('projectStore', 'looperStore')
@observer
class StudioVideo extends Component {
    @observable videoUploading = false;

    @action setVideoUploading = (val) => {
        this.videoUploading = val;
    };

    componentWillMount() {
        const {projectStore, looperStore} = this.props;
        projectStore.initVideos(looperStore.loopedProject.videoUrls || []);
    }

    handleFileChange = async (files) => {
        const file = files[0];
        this.setVideoUploading(true);
        await this.props.projectStore.uploadVideoToS3(file);
        this.setVideoUploading(false);
        customEvent(events.CustomEvent, {category: category.Studio, action: actions.AddVideo});

    };

    handleClickVideo = () => {
        customEvent(events.CustomEvent, {category: category.Studio, action: actions.ClickAddVideo});
    }

    handleRemoveVideo = index => () => {
        customEvent(events.CustomEvent, {category: category.Studio, action: actions.RemoveVideo});
        this.props.projectStore.removeVideo(index);
    };

    render() {
        const {previewMode, projectStore, isReadOnly} = this.props;

        return (
            <div className="m-studio-video">
                <div className="m-studio-heading"><FormattedMessage id="studio.videos.heading"/></div>
                <div className="m-studio-content">
                    {isReadOnly && <StudioReadOnlyMessage/>}
                    {!previewMode && !isReadOnly && <FileAttach
                        fileExtension="video/*"
                        onChange={this.handleFileChange}
                        onClick={this.handleClickVideo}
                        className="m-studio-attachments">
                        <button className="m-studio-btn">
                            <div className="icon"><SvgIcon viewBox="0 0 20 20">{iconVideo}</SvgIcon></div>
                            <div className="name"><FormattedMessage id="studio.videos.attachmentBtn"/></div>
                        </button>
                    </FileAttach>}
                    {this.videoUploading && <CircularLoader/>}
                    {projectStore.videoUrls.map((video, index) => (
                        <VideoBox key={index} url={video.src} onRemove={this.handleRemoveVideo(index)} />
                    ))}
                </div>
            </div>
        );
    }
}

export default StudioVideo;
